import React from 'react'
import {
  ExperienceWrapper,
  ExperienceSectionHeader,
  ExperienceDivider,
  CardContainer
} from './Experience.styles'
import CardComponent from './CardComponent'


import AppleLogo from "../../images/apple-logo.png"
import QpenQQuantifyLogo from '../../images/Openqquantify-logo.png'
import { ExperienceData } from '../Constants.js'

function ExperienceSection() {

  const images = {
    "Apple": AppleLogo,
    "OpenQQuantify": QpenQQuantifyLogo,
  }
  
  return (
    <ExperienceWrapper id="experience">
    <ExperienceSectionHeader>Technical Experience</ExperienceSectionHeader>
      <ExperienceDivider className='container'>
        <CardContainer>
        {
          ExperienceData.map((experience, idx) => (
            <CardComponent 
              key={idx}
              jobTitle={experience.jobTitle}
              companyLogo={images[experience.company]}
              company={experience.company}
              date={experience.date}
              bulletPoints={experience.bulletPoints}
             />
          ))
        }
        </CardContainer>
      </ExperienceDivider>
    </ExperienceWrapper>
  )
}

export default ExperienceSection
